import React, {useEffect, useState} from "react";

import {
	Col,
	Container,
	Row,
} from "reactstrap";

import {
	LocationWarning,
} from "../parts/GeneralPageElements";

import {BingMap} from "../parts/BingMap";

import "../../stylesheets/location-selection.scss";

import {
	InfoModalButton,
	NavButton,
	ToggleButton,
} from "../parts/Buttons";
import {AddressInput} from "../parts/AddressInput";
import {fromLonLat} from "ol/proj";
import {MYTREE} from "../../utilities/resources";

import {
	extractAddressComponents,
	getLatLngFromAddress,
} from "../../utilities/utilities";


export const LocationForm = (
	{
		activeImagery,
		features,
		headline,
		history,
		iconParameters,
		imagerySets,
		infoSubject,
		layers,
		location,
		maxZoom,
		navButtonParameters,
		parentWarning,
		zoom,
		subAddressbarText,
		handleBadResponse,
		handleGeolocation,
		handleAddressSearch,
		handleLocationUpdate,
		onMapClick,
		onMapMount,
		updateProject,
	}
) => {
	let [warning, setWarning] = useState("");
	let [_activeImagery, setActiveImagery] = useState(activeImagery);

	useEffect(
		() => {

		},
		[warning]
	)

	const validateAddress = (e = null) => {
		if (e) e.preventDefault();
		let addressInput = document.querySelector('.address-input');
		let feedback = addressInput.parentElement.nextSibling;

		if (!addressInput.value) {
			addressInput.classList.add("is-invalid");
			feedback.classList.add("is-invalid", "d-block");
		} else if (
			location.address.entered !== addressInput.value
		) {
			getLatLngFromAddress(addressInput.value).then(
				(response) => {
					if (response.status.toLowerCase() === "ok") {
						let result = response.results[0];
						let components = extractAddressComponents(result);
						let latitude = result.geometry.location.lat();
						let longitude = result.geometry.location.lng();
						handleLocationUpdate(
							addressInput.value,
							components,
							latitude,
							longitude,
							history.push(
								navButtonParameters.path
							)
						);
					} else {
						handleBadResponse(response);
					}
				}
			);
		} else {
			setWarning("");
		}
	};

	const switchLayers = (value) => {
		setActiveImagery(value);
	};

	const handleChange = (e) => {
		updateProject(
			{
				location: {
					address: {
						entered: e.currentTarget.value,
					},
				},
			},
			warning !== "" ? setWarning("") : null
		);
	};

	let _location = JSON.parse(JSON.stringify(location));
	let disabled = _location.address.entered.length <= 0;
	let center = fromLonLat([_location.longitude, _location.latitude]);
	let baseLayerToggleButtonSettings = [
		{text: "Streets", color: "primary"},
		{text: "Satellite", color: "primary"},
	];

	return (
		<React.Fragment>
			<Container fluid>
				<Row className={"mt-1 mt-lg-3"}>
					<Col
						xs={{size: 12}}
						lg={{size: 3}}
						xl={{size: 2}}
					>
						<p className={"h4 mb-0 text-center text-lg-left"}>
							{headline}
						</p>
					</Col>
					<Col
						xs={{size: 10}}
						lg={{size: 7}}
						xl={{size: 8}}
					>
						<AddressInput
							location={location}
							handleBadResponse={handleBadResponse}
							onChange={handleChange}
							handleGeolocation={handleGeolocation}
							handleAddressSearch={handleAddressSearch}
							warning={warning}
						/>
					</Col>
					<Col xs={{size: 2}}>
						<InfoModalButton
							className={"float-end"}
							subject={infoSubject}
						/>
					</Col>
				</Row>
				{parentWarning ?
					<Row>
						<Col className={"text-center"}>
							<em className={"text-danger"}>
								{parentWarning}
							</em>
						</Col>
					</Row>
					:
					null
				}
				{warning ?
					<Row>
						<Col className={"text-center"}>
							<em className={"text-danger"}>
								{warning}
							</em>
						</Col>
					</Row>
					:
					null
				}
				<Row>
					<Col className={"mt-1 mt-lg-1 text-center"}>
						<small className={"fst-italic"}>
							{subAddressbarText}
						</small>
						<BingMap
							center={center}
							layers={layers || []}
							features={features || []}
							zoom={zoom}
							maxZoom={maxZoom}
							iconParameters={iconParameters}
							imagerySets={imagerySets}
							activeImagery={_activeImagery}
							onMapClick={onMapClick}
							onMapMount={onMapMount}
						/>
					</Col>
				</Row>
				<Row className={"mt-3"}>
					<Col
						className={"d-none d-lg-block"}
						lg={{size: 5}}
					>
						<LocationWarning/>
					</Col>
					<Col
						xs={{size: 12}}
						sm={{size: 6, offset: 0}}
						lg={{size: 3}}
						xl={{size: 4}}
					>
						{MYTREE ?
							<ToggleButton
								className={"float-sm-none float-lg-right"}
								toggleFunction={switchLayers}
								id={"layers"}
								selected={_activeImagery}
								settings={baseLayerToggleButtonSettings}
							/>
							:
							null
						}
					</Col>
					<Col
						className={"mt-4 mt-sm-0 text-end"}
						xs={{size: 12}}
						sm={{size: 6}}
						lg={{size: 4}}
						xl={{size: 3}}
					>
						<NavButton
							className={"float-sm-right round"}
							color={"success"}
							disabled={disabled}
							function={validateAddress}
							path={navButtonParameters.path}
							rightIcon={"arrow-right"}
							text={navButtonParameters.text}
							title={"Proceed to the next page"}
						/>
					</Col>
				</Row>
				<Row className={"d-block d-lg-none mt-3 text-center"}>
					<Col
						sm={{size: 8, offset: 2}}
						lg={{size: 4, offset: 4}}
					>
						<LocationWarning/>
					</Col>
				</Row>
			</Container>
		</React.Fragment>
	);
};
